import { render, staticRenderFns } from "./propertyAccountList.vue?vue&type=template&id=c6a67cd6&scoped=true"
import script from "./propertyAccountList.vue?vue&type=script&lang=js"
export * from "./propertyAccountList.vue?vue&type=script&lang=js"
import style0 from "./propertyAccountList.vue?vue&type=style&index=0&id=c6a67cd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a67cd6",
  null
  
)

export default component.exports